import React from 'react';

type OwnProps = {
  className?: string;
};

const Caution = ({ className }: OwnProps) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g>
      <g>
        <path
          d="M6.717 43.94 26.304 12.6a2 2 0 0 1 3.392 0l19.587 31.34c.833 1.332-.125 3.06-1.696 3.06H8.413c-1.571 0-2.529-1.728-1.696-3.06z"
          stroke="#ffba45"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M27.631 34.987h.747c.21 0 .42-.187.443-.373l.91-6.557v-2.613a.459.459 0 0 0-.443-.444h-2.567a.459.459 0 0 0-.443.444v2.66l.91 6.51c.023.187.233.373.443.373zm-1.54 4.667c0 1.05.864 1.913 1.89 1.913a1.927 1.927 0 0 0 1.937-1.913c0-1.05-.863-1.937-1.937-1.937-1.026 0-1.89.887-1.89 1.937z"
          fill="#ffba45"
        />
      </g>
    </g>
  </svg>
);

export default Caution;
